export default "__VITE_ASSET__BucieZ5X__"